<template>
  <div class="strategy-state had-sync" v-if="state===1">
    <el-icon size="20">
      <SuccessFilled/>
    </el-icon>
    {{ $str.getKey('策略控制/已同步') }}
  </div>
  <el-tooltip effect="light" :content="$str.getKey('策略控制/eLink最后一次上报的需量和策略数据与eMind不一致')">
    <div class="strategy-state not-sync" v-if="state===2">
      <el-icon size="20">
        <CircleCloseFilled/>
      </el-icon>
      {{ $str.getKey('策略控制/未同步') }}
    </div>
  </el-tooltip>
  <div class="strategy-state syncing" v-if="state===3">
    <el-icon size="20" class="strategy-loading">
      <!-- <Loading/> -->
      <Refresh class="fresh" />
    </el-icon>
    {{ $str.getKey('策略控制/同步中') }}
  </div>
</template>

<script setup>
// import {CircleCloseFilled, Loading, SuccessFilled} from "@element-plus/icons-vue";
const $str = window.$str;
const props = defineProps(['state'])
</script>

<style scoped lang="scss">
.strategy-state {
  min-width: 80px;
  height: 30px;
  padding: 12px ;
  margin-left: 4px;
  border-radius: 15px;
  color: #5B80FF;
  box-shadow: inset 0px 0px 8px 4px currentColor;
  display: inline-flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  &.had-sync {
    color: #24F293;
  }
  &.not-sync {
    color: #F9173D;
  }
  &.syncing {
    color: #FFC209;
    .fresh {
      background-color:#FFC209;
      border-radius: 50%;
      color: #1f2536;
      transform: rotateX(180deg);
    }
  }
}

.strategy-loading {
  animation: loading-rotate 2s infinite linear;
}

@keyframes loading-rotate {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

</style>
